import React, { Component } from "react";
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import FooterModal from "../../../comum/components/FooterModal"
import { Container, Row, Col, Button, Label, FormGroup, Input } from "reactstrap";
import lscache from 'lscache';
import Select from 'react-select';
import { inject, observer } from "mobx-react";
import DataWrapper from "../../../principal/containers/DataWrapper";
import Card from "../../../comum/components/Card";
import CheckboxDetalhado from "../../../comum/components/CheckboxDetalhado";
import FormInput from "../../../comum/components/FormInput";
import FormInputNumber from "../../../comum/components/FormInputNumber";
import AgendamentoCadastrarStore from "../stores/AgendamentoCadastrarStore";
import FormSelect from "../../../comum/components/FormSelect";
import ModalForm from "../../../comum/components/ModalForm";
import ModalAviso from "../../../comum/components/ModalAviso";
import Footer from "../../../comum/components/Footer";
import { isInvalidoPlacas } from "../../../../utils/validadores";
import { RetiradaForm } from "../retirada-containers/components/RetiradaForm";
import { RetiradaDepotForm } from "../retirada-containers-depot/components/RetiradaDepotForm";
import { RetiradaDepotDryForm } from './../retirada-containers-dry/components/RetiradaDepotDryForm';
import { RetiradaDepotDryAlimentoForm } from '../retirada-containers-dry-alimento/components/RetiradaDryAlimentoForm';
import { IconeCarregar, Fechar } from "../../../comum/components/Icones";
import ContainerCheio from "../entrada-containers/components/ContainerCheio";
// import AreaExternaContainerVazio from "../area-externa-entrada-container-vazio/components/ContainerCheio";
import ImportacaoEntradaDepot from "../importacao-entrada-depot/components/ImportacaoEntradaDepot"
import DesistenciaForm from "../desistencia-containers/components/DesistenciaForm";
import ModalMultiplaEscolha from "../../../comum/components/ModalMultiplaEscolha";
import { Redirect } from "react-router-dom";
import { setTemaSeletor } from "../../../../utils/formatar";


import _ from 'lodash';
import moment from 'moment';
import { observable, toJS } from "mobx";
import { RetiradaDepotDevolucao } from './../retirada-containers-devolucao/components/RetiradaDepotDevolucao';
import Checkbox from "../../../comum/components/Checkbox";
import CardDetalhe from "../../../comum/components/CardDetalhe";

@inject("store")
@DataWrapper
@observer
export class AgendamentoCadastrar extends Component {
    
    @observable codigoBooking;
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;  
        this.parametrosStore = this.props.store.parametrosStore;
        this.parametrosStore.carregarAgendamento();
        this.controller = new AgendamentoCadastrarStore();
        this.codigoBooking = _.get(this.props.location.state, `codigoBooking`);
        this.state = {
            salvo: false,
            toAgendamento: false,
            idEdicao: false,
            novoAgendamento: false,
            copiarAnterior: false,
            agendaAnterior: _.get(this.props.location.state, `agendaAnterior`),
            tipoAgendaAnterior: _.get(this.props.location.state, `tipoAgendaAnterior`),
            dadosAgendaAnterior: _.get(this.props.location.state, `dadosAgendaAnterior`),
            motorista: [],
            alertaCnh: "",

        };
        this.contadorDaNota = 0;
        this.controller.setTerminalParaCamposObrigatorios(!process.env.rig ? "SSA" : "RIG")

        this.setStatusSalvo = this.setStatusSalvo.bind(this);
        this.handleMudaTipoAgenda = this.handleMudaTipoAgenda.bind(this);

        //Copiar dados do agendamento anterior
        if (this.state.agendaAnterior) {
            this.controller.setDadosAgendaAnterior(this.state.dadosAgendaAnterior);
            this.handleMudaTipoAgenda(this.state.tipoAgendaAnterior, this.state.agendaAnterior);
        }
    };
    componentDidMount() {
        this.editar();

        this.controller.carregarTiposAgendamentos();
        this.controller.carregarCategoriasCNH();

        /* Se Salvador, o carregamento das transportadoras agora será feito após escolha do Tipo de Agendamento
           pois a lista é diferente para agendamentos do Depot. 
           Para RIG foi mantido o modo anterior evitar prejudicar o funcionamento.
        */
        if(process.env.rig)
            this.controller.carregarTransportadoras();

        let dadosAgendamento = _.get(this.props.location.state, `dados`);
        let voltarParam = _.get(this.props.location.state, `voltar`);
        let dataAgendamento = _.get(this.props.location.state, `data`);
        let horaAgendamento = _.get(this.props.location.state, `hora`);
        let fainaAgendamento = _.get(this.props.location.state, `faina`);

        if (dadosAgendamento && !this.state.agendaAnterior) {
            this.handleMudaTipoAgenda(dadosAgendamento);
            this.handleChangeData(dataAgendamento);
            this.controller.setHoraAgend(horaAgendamento);
        }

        if (dataAgendamento) {
            lscache.set(`dashboard-data`, moment(dataAgendamento.value).format("YYYY-MM-DD"), 15);
        }
        if (fainaAgendamento) {
            lscache.set(`dashboard-faina`, fainaAgendamento, 15);
        }

        this.appStore.showTopbar(true);
        this.appStore.showVoltarTopBar(true, voltarParam ? voltarParam : '/agendamento-container');

        this.handleCopiarAnterior = this.handleCopiarAnterior.bind(this);
        this.setState({ agendaAnterior: false });
    };

    editar = () => {
        if (this.props.match.params.id) {
            this.tituloPaginaStore.setTitulo(`Agendamento de Container`);

            this.controller.tudoPronto = false;
            this.controller.isEditar = true;
            this.controller.iniciaEdicao(this.props.match.params.id, this.parametrosStore.mudaTipoAgendamento);
            this.mostra();
            console.log('controlador agendamento cadastrar', this.controller)
        } else {
            this.tituloPaginaStore.setTitulo("Novo Agendamento de Container");

            this.controller.isEditar = false;
            this.controller.tudoPronto = true;
        }
    };

    handleMudaTipoAgenda = (dados) => {
        console.log('tipo', dados)
        this.controller.mudaTipoAgenda(dados, this.state.agendaAnterior);
        this.setState({ salvo: false });
        if (dados) {
            this.parametrosStore.mudaTipoAgendamento(dados.value);
            this.mostra();
        }
    };

    handleChangeData = (event) => {
        this.controller.setDadosAgendamento("Agend.DatAgend", event);
        this.controller.setDadosAgendamento("Agend.HoraAgend", false);
        this.controller.listaHoras = [];
        this.controller.carregarListaHoras(event);
    };

    handleFinalizar = () => {
        this.setState({ salvo: false });
        this.controller.onClickFinalizarAgendamento();
        setTimeout(function () {
            this.setState({ salvo: true });
        }.bind(this), 2)
    };

    setStatusSalvo = (bool) => {
        this.setState({ salvo: bool });
    }

    handleSalvarNota = () => {
        {/** TODO: Criado para teste. Remover quando salvamento de notas estiver finalizado */ }
        this.setState({ salvo: false });
        this.controller.onClickSalvarNotaFiscal();
        setTimeout(function () {
            this.setState({ salvo: true });
        }.bind(this), 2)
    }
    MostrarTextoPesoDocumentalNota=()=>{
        document.getElementById("notaFinalizar").style.visibility = "visible"
    }
    RemoverTextoPesoDocumentalNota=()=>{
        document.getElementById("notaFinalizar").style.visibility = "hidden"
    }
    handleCheckboxClick = (controller) => {
        this.controller.notaFiscalNObrigatoria = ! this.controller.notaFiscalNObrigatoria;
        if(controller.dadosAgendamento.DAT && controller.dadosAgendamento.DAT.AgendamentoContemDAT){
            controller.listaMensagens = ["Não é possível selecionar essa opção quando o DAT é informado."];
            this.controller.notaFiscalNObrigatoria = false;
        }
    }
    checkboxNotaFiscal = () => {
        if (this.controller.mostraNfNaoObrigatoria)
            return (
                <CheckboxDetalhado 
                    titulo={"Nota fiscal não obrigatória"}
                    descricao={""}
                    checked={this.controller.notaFiscalNObrigatoria}               
                    onClick={() => {
                    this.controller.notaFiscalNObrigatoria = !this.controller.notaFiscalNObrigatoria;
                    if (this.controller.dadosAgendamento.DAT.AgendamentoContemDAT) {
                        this.controller.dadosAgendamento.DAT.AgendamentoContemDAT = !this.controller.dadosAgendamento.DAT.AgendamentoContemDAT;
                    }
                    
                    this.zerarObjetoNota()
                }}/>
            );
    };
    zerarObjetoNota() {
        if (!this.controller.notaFiscalNObrigatoria) {
            this.controller.objetoDeNotaFiscalNaoObrigatoria.outros = '';
            this.controller.objetoDeNotaFiscalNaoObrigatoria.observacoes = '';
            this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedBagagem = false;
            this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedVazio = false;
            this.controller.NotaFiscalNaoObrigatoria.validarOutros = false;
            document.addEventListener("DOMContentLoaded", function (event) {
                document.getElementById('outrosTextCheck').disabled = false;
                document.getElementById('Unidadevazia').disabled = false;
                document.getElementById('checksNotaBagagem').disabled = false;
            });
        }
    }

    checkboxArea = () => {
        if (!this.appStore.isMobile()) {
            return <Col xs={12} sm={12} lg={4}>
                {this.checkboxNotaFiscal()}
                {this.MostrarchekBox()}
            </Col>
        } else {
            let buffer = [];
            buffer.push(<Col key={2} xs={6} sm={6}>
                {this.checkboxNotaFiscal()}
                {this.MostrarchekBox()}
            </Col>);
            return buffer;
        }
    };

    mostra = () => {
        if (this.parametrosStore.terminal) {
            this.controller.terminal = this.parametrosStore.terminal;
            this.controller.mostraNfNaoObrigatoria = this.parametrosStore.isAgendamentoVisible("ListaContainerNfNaoObrigatoria");
            if(process.env.ssa)
                this.controller.carregarTransportadoras();
        } else {
            setTimeout(function () {
                this.mostra();
            }.bind(this), 1000)
        }
    };

    handleChangePlaca(campo, event) {
        if (event && event.target.value)
            event.target.value = event.target.value.toUpperCase();
        this.controller.setDadosAgendamento(campo, event)
    };

    handleChangeTransportadora = async (event) => {
        this.controller.carregarDocumentosRetirada(event);
        const cnpjtransp = await this.controller.service.recuperarCnpjTransportadora(event.value);
        const cnpj = cnpjtransp.data;
        this.setState({cnpj})
        this.controller.setDadosAgendamento(process.env.ssa  && ["DRE", "DRED", "DREDA", "DDI", "DREDD"].indexOf(this.controller.tipoAgendaAtivo.codIdentificador) > -1 ? "Agend.TranspIdDepot" : "Agend.TranspId", event);
        this.controller.setTransportadorasNotaFiscal(event);
    };

    handleCNPJ = (event)=>{
        const {value} = event.target;
        this.setState({ cnpjtransp: value});
    }

    
    handleChangeMotorista = (event) => {
        this.controller.setDadosAgendamento("Agend.MotoristaId", event);
    };

    bloqueiaTransp = () => {
        if (this.controller.isEditar
            && this.controller.terminal === "RIG"
            && ["RCDICTAC", "RCDTC", "RCDTA", "DTC", "CRP"].indexOf(this.controller.tipoAgendaAtivo.codIdentificador) > -1)
            return true;
        return false;
    };

    cardVeiculo() {
        if (this.controller.atualiza)
            return <Col className="area-form" xs={12} sm={6} lg={4}>
                <Card title={"Veículo"}>
                    <Row>
                        <FormSelect xs={12} sm={12} md={6} titulo="Transportadora"
                            itens={this.controller.transportadoras}
                            objeto={this.controller.dadosAgendamento}
                            dado={ process.env.ssa  && ["DRE","DRED","DREDA","DDI","DREDD"].indexOf(this.controller.tipoAgendaAtivo.codIdentificador) > -1 ? "Agend.TranspIdDepot" : "Agend.TranspId"}
                            itensValor="TranspId" itensLabel="ApelidoTransp"
                            bloqueado={this.bloqueiaTransp()}
                            //alerta={ (this.state.salvo && !_.has(this.controller.dadosAgendamento, "Agend.TranspId")) ? "Campo obrigatório" : "" }
                            onChange={this.handleChangeTransportadora} />
                          {/* {
                          ['DREDD'].indexOf(this.controller.tipoAgendaAtivo.codIdentificador) !== -1 ? <FormSelect xs={12} sm={12} md={6} titulo="Motorista"
                            itens={this.controller.motoristas}
                            objeto={this.controller.dadosAgendamento}
                            dado={"Agend.MotoristaId"}
                            itensValor="CampoValue" itensLabel="CampoDescricao"
                            //alerta={ (this.state.salvo && !_.has(this.controller.dadosAgendamento, "Agend.TranspId")) ? "Campo obrigatório" : "" }
                            onChange={this.handleChangeMotorista} /> : ""
                            } */}
                        <FormInput titulo="CNPJ" xs={12} sm={12} md={6}
                            value={this.state.cnpj}
                            uppercase={true}
                            bloqueado={true}/> 
                        <FormInput titulo="Placa cavalo" xs={12} sm={12} md={6}
                            uppercase={true}
                            objeto={this.controller.dadosAgendamento}
                            dado={"Agend.PlacaCavalo"}
                            validador={isInvalidoPlacas}
                            validacaoStore={this.controller.setValidacao}
                            //alerta={ (this.state.salvo && !_.has(this.controller.dadosAgendamento, "Agend.PlacaCavalo") && this.controller.terminalObrigatorios !== "SSA") ? "Campo obrigatório" : "" }
                            onChange={event => this.handleChangePlaca("Agend.PlacaCavalo", event)} />
                        <FormInput titulo="Placa carreta 1" xs={12} sm={12} md={6}
                            uppercase={true}
                            objeto={this.controller.dadosAgendamento}
                            dado={"Agend.PlacaCarret1"}
                            validador={isInvalidoPlacas}
                            validacaoStore={this.controller.setValidacao}
                            //alerta={ (this.state.salvo && !_.has(this.controller.dadosAgendamento, "Agend.PlacaCarret1") && this.controller.terminalObrigatorios !== "SSA") ? "Campo obrigatório" : "" }
                            onChange={event => this.handleChangePlaca("Agend.PlacaCarret1", event)} />
                        <FormInput titulo="Placa carreta 2" xs={12} sm={12} md={6}
                            uppercase={true}
                            objeto={this.controller.dadosAgendamento}
                            dado={"Agend.PlacaCarret2"}
                            validador={isInvalidoPlacas}
                            validacaoStore={this.controller.setValidacao}
                            onChange={event => this.handleChangePlaca("Agend.PlacaCarret2", event)} />
                    </Row>
                </Card>
            </Col>
    };
    cardMotorista = () => {
        if (this.controller.atualiza)
            return <Col className="area-form" xs={12} sm={6} lg={4}>
                <Card title={"Motorista"}>
                    <Row>
                        <FormInputNumber titulo="CNH" xs={12} sm={12} md={6}
                            alerta = {this.state.alertaCnh}
                            objeto={this.controller.dadosAgendamento}
                            dado={"Motorista.N4DriverLicense"}
                            onChange={event =>  {
                                const cnhValue = event.target.value;
                                if (cnhValue.length >= 4) {
                                  this.setState({ alertaCnh: "" }); // Limpa o alerta
                                } else {
                                  // Define o estado alertaCnh com a mensagem de erro
                                  this.setState({ alertaCnh: "Minimo de 4 dígitos" });
                                }
                                this.controller.setDadosAgendamento("Motorista.N4DriverLicense", event);
                              }
                                }
                            onBlur={event => {
                                const cnhValue = event;
                                console.log(cnhValue)
                                if (cnhValue.length >= 4) {
                                  this.controller.onBlurMotoristaCNH();
                                } else {
                                     
                                    this.setState({ alertaCnh: "Minimo de 4 dígitos" });
                                }
                              }} />
                        <FormSelect xs={12} sm={12} md={6} titulo="Categoria"
                            itens={this.controller.categoriasCnh}
                            objeto={this.controller.dadosAgendamento}
                            dado={"Motorista.CategCnh"}
                            itensValor="Id.RvLowValue" itensLabel="Id.RvLowValue"
                            bloqueado={_.get(this.controller.dadosAgendamento, "Motorista.MotoristaCategCnh_Bloqueado") || this.controller.bloqueiaCamposMotoristaCat}
                            onChange={(event) => this.controller.setDadosAgendamento("Motorista.CategCnh", event)} />
                        <FormInput titulo="Nome completo" xs={12} sm={12} md={7}
                            objeto={this.controller.dadosAgendamento}
                            dado={"Motorista.Nome"}
                            bloqueado={_.get(this.controller.dadosAgendamento, "Motorista.MotoristaNome_Bloqueado") || this.controller.bloqueiaCamposMotoristaNome}
                            onChange={event => this.controller.setDadosAgendamento("Motorista.Nome", event)} />
                        <FormInput titulo="CPF" xs={12} sm={12} md={5}
                            objeto={this.controller.dadosAgendamento}
                            dado={"Motorista.Cpf"}
                            bloqueado={_.get(this.controller.dadosAgendamento, "Motorista.MotoristaCpf_Bloqueado") || this.controller.bloqueiaCamposMotoristaCpf}
                            onChange={event => this.controller.setDadosAgendamento("Motorista.Cpf", event)} />
                    </Row>
                </Card>
            </Col>
    };
        tabelasArquivo = () => {
        if (!this.controller.notaFiscalNObrigatoria) return null;
      
        return (
          <Row>
            <Col xl={12}>
              <div className="card-expansivel card-expansivel-tabela">
                <div className="card">
                  <Row className="titulo-booking align-items-center">
                    <Col xs={6}>
                      <h4>Documentos</h4>
                    </Col>
                    <Col xs={6} className="text-right">
                      <Button
                        color="primary"
                        onClick={() => document.getElementById('uploadArquivo').click()}
                      >
                        Escolher arquivo
                      </Button>
                      <input
                        type="file"
                        id="uploadArquivo"
                        style={{ display: 'none' }}
                        onChange={(e) => {
                          const evento = e.target
                          const arquivo = evento.files;
                          const hoje = Date.now();
                          const dt = new Date(hoje);
                          const dataEhoraAtual = dt.toLocaleDateString('pt-br') + "\n" + dt.getHours() + ":" + dt.getMinutes();
                        
                          const reader = new FileReader();
                          reader.onload = () => {
                            const base64String = reader.result.split(',')[1];
                        
                            const newFileNota = {
                              Arquivo: base64String,
                              FileId: '',
                              NomeDoArquivo: arquivo[0].name.split("\\").pop(),
                              dataEhoraEmQueFoiFeitoUpload: dataEhoraAtual,
                              agendaId: this.controller.agendId,
                              TipoArquivo: arquivo[0].name.split('.').pop(),
                            };
                        
                            this.controller.objetoDeNotaFiscalNaoObrigatoria.fileNota.replace([newFileNota]);
                            evento.value = null;
                          };
                        
                          reader.readAsDataURL(arquivo[0]);
                        }}
                        />
                    </Col>
                  </Row>
      
                  <hr />
      
                  {this.controller.objetoDeNotaFiscalNaoObrigatoria.fileNota.length > 0 ? (
            <Row key={this.controller.objetoDeNotaFiscalNaoObrigatoria.fileNota[0].NomeDoArquivo} className="align-items-center mb-2">
    <Col>{this.controller.objetoDeNotaFiscalNaoObrigatoria.fileNota[0].NomeDoArquivo}</Col>
    <Col xs="auto">
      <Button
        color="danger"
        size="sm"
        onClick={() => {
          this.controller.apareceModalDeExclusao = true;
          this.controller.idDoArquivo = this.controller.objetoDeNotaFiscalNaoObrigatoria.fileNota[0];
        }}
      >
        Remover
      </Button>
    </Col>
  </Row>
) : (
  <Row>
    <Col className="text-muted">Nenhum arquivo enviado</Col>
  </Row>
)}

                </div>
              </div>
            </Col>
          </Row>
        );
      };
    cardDAT() {
        if (this.controller.atualiza && this.controller.tiposAgendaEntradaCheio.includes(this.controller.tipoAgendaAtivo.codIdentificador)) {
            if (!this.controller.dadosAgendamento.DAT) this.controller.dadosAgendamento.DAT = {};
            return (
                <Col className="area-form" xs={12} sm={6} lg={4}>
                    <Card title={"DAT"}>
                        <Row>
                            <Checkbox
                                valor="DAT necessário"
                                ativo={this.controller.dadosAgendamento.DAT.AgendamentoContemDAT || false}
                                obrigatorio={false}
                                bloqueado={false}
                                xs={6} md={4} lg={3}
                                onChange={checked => {
                                    this.controller.dadosAgendamento.DAT.AgendamentoContemDAT = checked;
                                    if (!checked) {
                                        this.controller.dadosAgendamento.DAT.NumeroDAT = null;
                                        this.controller.dadosAgendamento.DAT.ArquivoDAT = null;
                                    }
                                    this.controller.notaFiscalNObrigatoria = false;
                                    this.forceUpdate();
                                }}
                            />
                            {this.controller.dadosAgendamento.DAT.AgendamentoContemDAT && (
                                <React.Fragment>
                                    <FormInput 
                                        titulo="Número DAT" 
                                        xs={12} sm={12} md={6}
                                        objeto={this.controller.dadosAgendamento}
                                        dado={"DAT.NumeroDAT"}
                                        onChange={event => this.handleChangeNumeroDAT(event)}
                                    />
                                    {this.controller.dadosAgendamento.Agend && this.controller.dadosAgendamento.DAT.NumeroDAT && (
                                        <React.Fragment>
                                            <FormInput 
                                                titulo="Upload de Arquivo (PDF)" 
                                                type="file" 
                                                accept=".pdf" 
                                                xs={23} sm={23} md={6}
                                                onChange={event => this.handleFileUpload("DAT.ArquivoDAT", event)}
                                            />
                                            {this.controller.dadosAgendamento.DAT.ArquivoDAT && (
                                                <CardDetalhe 
                                                    desc={
                                                        <span 
                                                            style={{ cursor: 'pointer', textDecoration: 'none', color: '#inherit' }}
                                                            onClick={ event => this.handleVisualizarArquivo(this.controller.dadosAgendamento.DAT.ArquivoDAT)}
                                                        >
                                                            📥Visualizar documento
                                                        </span>
                                                    }
                                                />
                                            )}
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            )}
                        </Row>
                    </Card>
                </Col>
            );
        }
    }
    
    base64ToPdfBlob = (base64) => {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    };

    handleVisualizarArquivo (base64) {
        const blob = this.base64ToPdfBlob(base64, "application/pdf");
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
    }

    handleFileUpload(campo, event) {
        const file = event.target.files[0];

        if (!file) {
            _.set(this.controller.dadosAgendamento, campo, null);
            this.forceUpdate();
            return;
        }

        if (file.type !== "application/pdf") {
            this.controller.listaMensagens = ["Arquivo deve ter formato PDF."];
            _.set(this.controller.dadosAgendamento, campo, null);
            this.forceUpdate();
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            const base64 = reader.result.split(",")[1];
            _.set(this.controller.dadosAgendamento, campo, base64);
            this.forceUpdate();
        };

        reader.readAsDataURL(file);
    }

    handleChangeNumeroDAT(event) {
        const value = event.target.value;

        if(value && value.trim() !== ""){
            this.controller.dadosAgendamento.DAT.NumeroDAT = value; 
        } else {
            this.controller.dadosAgendamento.DAT.NumeroDAT = null;
            this.controller.dadosAgendamento.DAT.ArquivoDAT = null; 
        }
        
        this.forceUpdate();
    };

    formRetirada() {
        if (this.controller.tipoAgendaRetirada > -1) {
            return <RetiradaForm
                tipoAgenda={this.controller.tipoAgendaAtivo.codIdentificador}
                agendamentoController={this.controller} />
        } else return null;
    };

    formEntrada() {
        if (this.controller.tipoAgendaEntrada > -1) {
            return <ContainerCheio
                tipoAgenda={this.controller.tipoAgendaAtivo.codIdentificador}
                agendamentoController={this.controller}
                salvo={this.state.salvo}
                setStatusSalvo={this.setStatusSalvo}
                codigoBooking={this.controller.codigoBooking} />
        } else return null;
    };

    // formEntradaVazioAreaExterna() {
    //     console.log('teste', this.controller.tipoAgendaEntrada, this.controller.tipoAgendaAtivo)
    //     if (this.controller.tipoAgendaEntrada > -1) {
    //         return <AreaExternaContainerVazio
    //             tipoAgenda={this.controller.tipoAgendaAtivo.codIdentificador}
    //             agendamentoController={this.controller}
    //             salvo={this.state.salvo}
    //             setStatusSalvo={this.setStatusSalvo}
    //             codigoBooking={this.controller.codigoBooking} />
    //     } else return null;
    // };

    formEntradaDepotImportacao() {
        if (this.controller.tipoEntradaImportacaoDepot > -1) {
            return <ImportacaoEntradaDepot
            tipoAgenda={this.controller.tipoAgendaAtivo.codIdentificador}
            agendamentoController={this.controller}
            salvo={this.state.salvo}
            setStatusSalvo={this.setStatusSalvo}
            codigoBooking={this.controller.codigoBooking} 
                />
        } else return null;
    };


    formDesistencia() {
        if (this.controller.tipoAgendaDesistencia > -1) {
            return <DesistenciaForm
                agendamentoController={this.controller}
            />
        } else return null
    }

    formRetiradaDesistencia() {
        if (this.controller.tipoAgendaRetiradaDevolucao > -1) {
            return <RetiradaDepotDevolucao
                tipoAgenda={this.controller.tipoAgendaAtivo.codIdentificador}
                agendamentoController={this.controller} />
        } else return null;
    };

    formRetiradaDepot() {
        if (this.controller.tipoAgendaRetiradaDepot > -1) {
            return <RetiradaDepotForm
                tipoAgenda={this.controller.tipoAgendaAtivo.codIdentificador}
                agendamentoController={this.controller} />
        } else return null;
    };
    
    formRetiradaDepotDry() {
        if (this.controller.tipoAgendaRetiradaDepotDry > -1) {
            return <RetiradaDepotDryForm
                tipoAgenda={this.controller.tipoAgendaAtivo.codIdentificador}
                agendamentoController={this.controller} />
        } else return null;
    }
    
    formRetiradaDryAlimento() {
        if (this.controller.tipoAgendaRetiradaDepotDryAlimento > -1) {
            return <RetiradaDepotDryAlimentoForm
                tipoAgenda={this.controller.tipoAgendaAtivo.codIdentificador}
                agendamentoController={this.controller} />
        } else return null;
    }

    mostrarInserir() {
        return (this.controller.mostrarInserirNovo.length > 0);
    }

    modalInserirNovo() {
        if (this.mostrarInserir())
            return <ModalForm salvando={this.controller.inserindoEmModal || this.controller.validandoXML}
                esconderSalvar={this.controller.mostrarInserirNovo === "NOTAFISCAL_XML" && (this.controller.erroImportXML || !this.controller.jsonFile)}
                className="area-form-modal"
                onClickCancelar={this.controller.fecharModais}
                onClickSalvar={this.controller.adicionarNovo} >
                <h2>{this.tituloModal()}</h2>
                {
                    this.controller.mostrarInserirNovo === "NOTAFISCAL_XML"
                        ? <Row>
                            <Col sm={12} md={12}>
                                <FormGroup>
                                    <Label>Inserir arquivo</Label>
                                    <Input
                                        type="file"
                                        onChange={e => this.controller.guardaXMLNotaFiscal(e)}
                                    />
                                    {this.mensagemErroXML()}
                                </FormGroup>
                            </Col>
                        </Row>
                        : <Row>
                            <Col sm={12} md={12}>
                                <FormGroup>
                                    <Label>Número</Label>
                                    <Input value={this.controller.codigoNovo}
                                        autoFocus={true} className="uppercase"
                                        onChange={e => this.controller.modificarCodigoNovo(e)} />
                                    {this.controller.padraoDeCodigoInvalido
                                        && <Col xs={12} className="col-label label-obrigatorio px-0">
                                            <Label>Padrão inválido</Label>
                                        </Col>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                }
            </ModalForm>
    }

    mensagemErroXML() {
        return this.controller.erroImportXML ?
            <div className='label-obrigatorio pt-2'>
                <Label> {this.controller.erroImportXMLMensagem} </Label>
            </div> : null;
    }

    tituloModal() {
        switch (this.controller.mostrarInserirNovo) {
            case "BOOKING": return "Novo Booking"
            case "BOOKING_CONTAINER": return "Novo Container"
            case "NOTAFISCAL": return "Nova Nota Fiscal"
            case "NOTAFISCAL_CONTAINER": return "Novo Container"
            default: break;
        }
    }

    modalErro() {
        { /** Se chegar no final do agendamento e houver erro apenas em alguma nota um outro modal é exibido (modalFimAgendamento) */ }
        if (this.controller.listaMensagens && !this.controller.modalFimAgendamento) {
            return <ModalAviso onClickFechar={() => this.controller.erroBookingTerminal ? this.controller.fecharModaisErro() : this.controller.fecharModais()}>
                {
                    this.controller.listaMensagens &&
                    this.controller.listaMensagens.map((msg, x) =>
                        <h2 key={x}>{msg}</h2>
                    )
                }
            </ModalAviso>
        }
    }
    
    
    handleCopiarAnterior = () => {
        this.controller.modalFimAgendamento = false;
        this.setState({ copiarAnterior: true });
    };

    handleRecarrega = () => {
        this.controller.modalFimAgendamento = false;
        this.setState({ novoAgendamento: true });
    };

    handleCorrigirNotas = () => {
        this.controller.corrigirNotasFiscais = true;
        this.controller.modalFimAgendamento = false;
    };

    handleDescartarNotas = () => {
        this.controller.modalFimAgendamento = true;
        this.controller.modalFimNotaFiscal = true;
    };

    handleComprovanteAgendamento = () => {
        this.controller.carregarAgendamentoResumo(this.controller.resultadoFimAgendamento.AgendId);
    };

    appendMensagemMotorista = () => {
        if (_.get(this.controller.resultadoFimAgendamento, 'MotoristaSemBiometria') &&
            _.get(this.controller.resultadoFimAgendamento, 'MensagemMotoristaSemBiometria')) {
            this.controller.resultadoFimAgendamento.Mensagem += `<br />${_.get(this.controller.resultadoFimAgendamento, 'MensagemMotoristaSemBiometria')}`;
        }
    };

    modalConfirmacaoCargaReefer() {
        if (this.controller.modalConfirmacaoCargaReefer) {
                return (<ModalMultiplaEscolha titulo={"Confirmação carga Reefer"}
                mensagem={"Os seguintes containers reefer foram agendados com tipo de mercadoria seca, portanto, sem temperatura. Deseja continuar?"}>                                  
                    {this.controller.cdCntrReefer.map(cntr =>
                        <h2> {cntr}<br /> </h2>        
                    )}                                          

                <div className="justify-content-end">
                    <Label className="btn-primary" onClick={() => this.controller.finalizarAgendamento()}>Confirmar</Label>
                    <Label className="btn-primary" onClick={this.controller.fecharModais}>Voltar</Label>
                </div>
            </ModalMultiplaEscolha>)
           
            
        }
    }

    modalFimAgendamento() {
        if (this.controller.modalFimAgendamento) {

            this.appendMensagemMotorista();

            return (<ModalMultiplaEscolha titulo={this.controller.resultadoFimAgendamento.Sucesso ? "Concluído" : ""}
                mensagem={this.controller.resultadoFimAgendamento.Mensagem}>

                <div className="justify-content-end">
                    <Label className="btn-primary" onClick={this.handleRecarrega}>Novo Agendamento</Label>
                    {["ECC", "ECCM", "ECV", "23ECV"].includes(this.controller.tipoAgendaAtivo.codIdentificador) && <Label className="btn-primary" onClick={this.handleCopiarAnterior}>Copiar Este Agendamento </Label>}
                    <Label className="btn-primary" onClick={() => this.setState({ idEdicao: this.controller.resultadoFimAgendamento.AgendId })}>Continuar editando</Label>
                    <Label className="btn-primary" onClick={() => this.setState({ toAgendamento: true })}>Consultar Agendamentos</Label>
                    <Label className="btn-primary" onClick={this.handleComprovanteAgendamento}>Ver resumo</Label>
                </div>

            </ModalMultiplaEscolha>)
        }
    }

    alertaSSA = () => {
        let alerta = ( <div />);        
        if (process.env.ssa) {
            alerta = (
                <div className="card-atencao">
                    <div className="d-flex w-100 justify-content-between align-items-center">
                        <div className="card-atencao--title"> 
                            NOTA
                        </div>
                            <Fechar tamanho="1x" className="card-atencao--close" onClick={() => this.controller.fechaAlerta()} />                                    
                    </div>
                    <div className={this.classLabel}>
                        <p className="mb-0 ml-1">
                            <label> É exigência da Receita Federal que a entrega de carga de exportação no Terminal seja identificada pelo CPF do motorista condutor do veículo que acesse o Tecon Salvador.
                            <br/>Caso o CPF do motorista esteja em situação cadastral irregular a carga poderá ficar pendente de desembaraço, impedindo seu embarque.</label>
                        </p>
                    </div>
                   
                </div>
                
            )
            
        }
        return alerta;
    }
    alertaSSA2 = () => {
        let alerta = (<div/>)
        if (process.env.ssa)
        {
        alerta = (     
                       
            <div class="alert alert-primary" role="alert">
                        <div className="card-atencao--title"> 
                        Atenção:
                        </div>
                        
                    As informações prestadas integram automaticamente com os sistemas aduaneiros e órgãos anuentes.
            </div>
        )
        }
        return alerta;
    }

    confirmarExclusaoDoDocumento = (e) => {
        return (<div>
            <ModalContainer zIndex={100} >
                <ModalDialog className={"nosso-modal modal-margin"}>
                    <FooterModal>
                        <div className="justify-content-end">
                            <Row>
                                <h4>Deseja confirmar a exclusão do arquivo?</h4>
                            </Row>
                            <Row>
                                <Button className="btn-primary" onClick={() => this.controller.apareceModalDeExclusao = false}>Cancelar</Button>
                                <Button className="btn-primary" onClick={() => this.excluirDocumentoNota(this.controller.NotaFiscalNaoObrigatoria.NotaId)}>Confirmar</Button>
                            </Row>
                        </div>
                    </FooterModal>
                </ModalDialog>
            </ModalContainer>
        </div>)
    }
    
    
    notafiscalNaoobrigatoriaObservacoes = (e) => {
        this.controller.objetoDeNotaFiscalNaoObrigatoria.observacoes = e;
    }
    notafiscalNaoobrigatoriaOutros = (valor) => {
        const controller = this.controller;
        controller.objetoDeNotaFiscalNaoObrigatoria.outros = valor;
      
        if (valor.length < 3) {
          controller.ValidarCampoOutros = true;
        } else {
          controller.ValidarCampoOutros = false;
        }
      };
      
    notafiscalNaoobrigatoriaVazia = () => {
        this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedVazio = !this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedVazio;
        if (this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedVazio) {
            document.getElementById('checksNotaBagagem').disabled = true;
            document.getElementById('outrosTextCheck').disabled = true;
        }
        else {
            document.getElementById('checksNotaBagagem').disabled = false;
            document.getElementById('outrosTextCheck').disabled = false;
        }
    }
    notafiscalNaoobrigatoriaBagagem = () => {
        this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedBagagem = !this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedBagagem;
        if (this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedBagagem) {
            document.getElementById('Unidadevazia').disabled = true;
            document.getElementById('outrosTextCheck').disabled = true;
        }
        else {
            document.getElementById('Unidadevazia').disabled = false;
            document.getElementById('outrosTextCheck').disabled = false;
        }
    }

    notafiscalNaoobrigatoriaOutrosCheck = () => {
        const controller = this.controller;
      
        // Alterna o checkbox de "Outros"
        controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedOutros =
          !controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedOutros;
      
        const marcado = controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedOutros;
        controller.NotaFiscalNaoObrigatoria.validarOutros = marcado;
      
        if (!marcado) {
          controller.objetoDeNotaFiscalNaoObrigatoria.outros = '';
          controller.ValidarCampoOutros = false;
        }
      
        if (marcado && (controller.objetoDeNotaFiscalNaoObrigatoria.outros || '').length < 3) {
          controller.ValidarCampoOutros = true;
        }
        
        // Forçar atualização do componente
        this.forceUpdate(); // Ou use um método de atualização do seu controller
      };
    
    baixarArquivo = (e) => {
        if (e.FileId != null && e.FileId != undefined) {
            this.controller.visualizarDocumento(e.FileId);
        }
        else {
            this.controller.listaMensagens = ["Ocorreu um problema ao baixar o documento"];
        }
    }
   excluirDocumentoNota = (notaId) => {
      this.controller.apareceModalDeExclusao = false;
      this.controller.objetoDeNotaFiscalNaoObrigatoria.fileNota = [];
      if (notaId && notaId !== '') {
        // Arquivo já enviado ao back
        this.controller.excluirDocumentoNota(notaId);
      }
    };

    MostrarchekBox = (e) => {
        let alerta = (<div />);
        if (this.controller.notaFiscalNObrigatoria) {
        alerta = (
            <Card title={"Selecione o motivo"}>
            <div style={{ padding: '10px' }}>
                {/* Unidade Vazia com Resíduo */}
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <label htmlFor="Unidadevazia" id="textoNotaFiscal" style={{ flexGrow: 1 }}>
                    Unidade vazia com resíduo
                </label>
                <Input
                    type="checkbox"
                    onChange={() => this.notafiscalNaoobrigatoriaVazia()}
                    name="myCheckbox"
                    id="Unidadevazia"
                    style={{ width: '10%', marginLeft: '65%' }}
                    checked={this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedVazio}
                    disabled={this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedOutros}
                />
                </div>
    
                {/* Bagagem */}
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <Input
                    type="checkbox"
                    onChange={() => this.notafiscalNaoobrigatoriaBagagem()}
                    name="myCheckbox"
                    id="checksNotaBagagem"
                    style={{ marginTop: '5px', width: '10%', marginLeft: '65%' }}
                    checked={this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedBagagem}
                    disabled={this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedOutros}
                />
                <label htmlFor="checksNotaBagagem" id="textoNotaFiscal" style={{ flexGrow: 2 }}>
                    Bagagem
                </label>
                </div>
    
                {/* Outros */}
                <div style={{ marginBottom: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label htmlFor="outrosTextCheck" id="textoNotaFiscal" style={{ flexGrow: 1 }}>
                    Outros:
                    </label>
                    <Input
                    type="checkbox"
                    onChange={this.notafiscalNaoobrigatoriaOutrosCheck}
                    checked={this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedOutros}
                    id="outrosTextCheck"
                    style={{ marginTop: '5px', width: '10%', marginLeft: '65%' }}
                    />
                </div>
    
                {this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedOutros && (
    <div>
        <FormInput 
        xs={12} 
        sm={12} 
        md={9}
        uppercase={true}
        objeto={this.controller.objetoDeNotaFiscalNaoObrigatoria}
        dado={"outros"}
        onChange={(e) => this.notafiscalNaoobrigatoriaOutros(e.target.value)}
        style={{ 
            alignSelf: 'left',
            textAlign: 'left'
        }}
        className="text-start align-self-start"
        />

        {this.controller.ValidarCampoOutros && (
        <p id="validarCaracters" style={{ color: 'red', marginTop: '5px' }}>
            Digite pelo menos 3 caracteres.
        </p>
        )}
    </div>
    )}

                </div>
            </div>
            </Card>
        );
        }
    
        return alerta;
    };
  
    verificaSeTemNotaNaoObrigatoria = () => {
        let temNota = false;
        let agendaId = 0;
        if (this.controller.isEditar) {
            if (this.controller.dadosAgendamento) {
                if (this.controller.dadosAgendamento.listaBookings[0]) {
                    let index2 = this.controller.dadosAgendamento.listaBookings[0].containers.length;
                    if (index2 > 0) {
                        for (let index = 0; index < index2; index++) {
                            if (this.controller.dadosAgendamento.listaBookings[0].containers[index].FlgNaoNota == 'S'
                                || this.controller.dadosAgendamento.listaBookings[0].containers[index].FlgNaoNota == 's') {
                                temNota = true;
                                agendaId = this.controller.dadosAgendamento.listaBookings[0].containers[index].AgendId;
                                break;
                            }
                        }
                    }
                }
            }
        }
        this.contadorDaNota++;
        if (temNota) {
            this.buscarNotaNaoObrigatoria(agendaId);
        }
    }
    async buscarNotaNaoObrigatoria(agendaId) {
        await this.controller.carregarNotaPorAgendaId(agendaId);
        await this.controller.carregarArquivoPorNotaId(this.controller.NotaFiscalNaoObrigatoria.NotaId);
        this.validarChecksBox();
    }
    validarChecksBox() {

        if (this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedVazio) {
            document.getElementById('checksNotaBagagem').disabled = true;
            document.getElementById('outrosTextCheck').disabled = true;
            const checkbox = document.getElementById("Unidadevazia")
            checkbox.checked = true // marcou            
        }
        if (this.controller.objetoDeNotaFiscalNaoObrigatoria.isCheckedBagagem) {
            document.getElementById('Unidadevazia').disabled = true;
            document.getElementById('outrosTextCheck').disabled = true;
            const checkbox = document.getElementById("checksNotaBagagem")
            checkbox.checked = true // marcou            
        }

        if (this.controller.NotaFiscalNaoObrigatoria.validarOutros) {
            document.getElementById('Unidadevazia').disabled = true;
            document.getElementById('checksNotaBagagem').disabled = true;
            const checkbox = document.getElementById("outrosTextCheck")
            checkbox.checked = true
            const outrosTextInput = document.getElementById('outrosText');
            outrosTextInput.style.pointerEvents = 'auto';
        }
    }
    render() {
        if (this.state.novoAgendamento) {
            this.setState({ novoAgendamento: false });
            if (this.controller.isEditar)
                return <Redirect to={"/agendamento-container/cadastro"} />
            else
                window.location.reload();
        }

        if (this.state.copiarAnterior) {
            this.setState({ copiarAnterior: false });
            let dadosCopiaAgendamento = {}
            dadosCopiaAgendamento.Agend = this.controller.dadosAgendamento.Agend;
            dadosCopiaAgendamento.listaBookings = toJS(this.controller.dadosAgendamento.listaBookings);
            dadosCopiaAgendamento.Motorista = this.controller.dadosAgendamento.Motorista;

            this.props.history.replace("/agendamento-container/cadastro",
                {
                    tipoAgendaAnterior: this.controller.tipoAgendaAtivo,
                    dadosAgendaAnterior: dadosCopiaAgendamento,
                    agendaAnterior: true
                }
            );
            window.location.reload();
        }

        if (this.state.idEdicao) {
            this.setState({ idEdicao: false });
            if (!this.controller.isEditar)
                return <Redirect to={`/agendamento-container/cadastro/${this.state.idEdicao}`} />
            else
                window.location.reload();
        }
        if (this.state.toAgendamento)
            return <Redirect to='/agendamento-container' />

        const selectTipoAgenda = <Row>
            <Col className="area-form"sm={6} md={4} xl={4}>
                <Row>
                    <Col xs={2} sm={2} md={2} xl={1}>
                        <Label className="label-tipo-ag" onClick={() => console.log(this.controller.dadosAgendamento)}>Tipo</Label>
                    </Col>
                    <Col xs={10} sm={10} md={10} xl={11}>
                        <Select className="select"
                            placeholder={"Selecione"}
                            isSearchable={this.controller.tiposAgenda.length > 5}
                            isDisabled={this.controller.isEditar}
                            value={this.controller.tipoAgendaAtivo}
                            onChange={this.handleMudaTipoAgenda}
                            noOptionsMessage={() => ("Não há opções")}
                            options={this.controller.tiposAgenda}
                            theme={theme => setTemaSeletor(theme)} />
                    </Col>
                </Row>
            </Col>
        </Row>

        return (
            <div className="form-wrapper">
                {this.controller.tudoPronto
                    && <div className={"content-panel"}>
                        <Container className="agendamento-cadastrar" fluid>
                            {selectTipoAgenda}
                            {this.controller.alertaSSA && this.controller.tiposAgendaEntrada.indexOf(this.controller.tipoAgendaAtivo.codIdentificador) !== -1 &&
                            <div>
                            <Row>
                              <Col xs={12} sm={12} md={12} xl={12}>
                                {this.alertaSSA()}
                                <br/>
                              </Col>
                            </Row>  
                                                 
                          </div>}
                             {this.controller.tiposAgendaEntrada.indexOf(this.controller.tipoAgendaAtivo.codIdentificador) !== -1 &&
                             <div>
                                <div className = "FecharAlerta2">
                                    <Row>
                                <Col>
                                    {this.alertaSSA2()}
                                </Col>
                                    </Row>
                                </div>
                            
                             
                             </div>     
                             }
                            {this.modalInserirNovo()}
                            {this.modalErro()}
                            {this.modalConfirmacaoCargaReefer()}
                            {this.modalFimAgendamento()}
                            {this.controller.isEditar && this.contadorDaNota == 0 ? this.verificaSeTemNotaNaoObrigatoria() : ''}

                            <Row>                                                                                                                      
                                {this.cardMotorista()}
                                {this.cardVeiculo()}
                                {this.cardDAT()}
                                {this.checkboxArea()}
                               
                            </Row>
                            
                            {this.tabelasArquivo()}
                            {this.controller.apareceModalDeExclusao ? this.confirmarExclusaoDoDocumento() : ''}
                            {!this.controller.atualizaBookings ? <div /> : this.formEntrada()}
                            {!this.controller.atualizaBookings ? <div /> : this.formRetirada()}
                            {!this.controller.atualizaBookings ? <div /> : this.formDesistencia()}
                            {!this.controller.atualizaBookings ? <div /> : this.formRetiradaDepot()}
                            {!this.controller.atualizaBookings ? <div /> : this.formRetiradaDepotDry()}
                            {!this.controller.atualizaBookings ? <div /> : this.formRetiradaDesistencia()}
                            {!this.controller.atualizaBookings ? <div /> : this.formRetiradaDryAlimento()}
                            {!this.controller.atualizaBookings ? <div /> : this.formEntradaDepotImportacao()}

                            
                            <Footer className="footer-opcoes justify-content-between">
                                {this.controller.atualizaData
                                    ? <Row className="area-form footer-content no-gutters">
                                        {this.controller.listaDatas.length > 0
                                            && <Col xs={12}
                                                md={this.controller.listaHoras.length > 0 ? { size: '4', offset: 3 } : { size: '4', offset: 4 }}
                                                lg={this.controller.listaHoras.length > 0 ? { size: '4', offset: 3 } : { size: '4', offset: 6 }}
                                                xl={this.controller.listaHoras.length > 0 ? { offset: 3 } : { offset: 6 }} className="pl-2">
                                                <FormGroup className="footer-select">
                                                    <Label className="footer-select--label">Data</Label>
                                                    <Select className="select" placeholder={""}
                                                        noOptionsMessage={() => { "Sem opções" }}
                                                        isClearable={true}
                                                        isSearchable={this.controller.listaDatas.length > 5}
                                                        value={this.controller.listaDatas.filter(option => option.value === _.get(this.controller.dadosAgendamento, "Agend.DatAgend"))}
                                                        onChange={this.handleChangeData}
                                                        menuPlacement="auto"
                                                        options={this.controller.listaDatas}
                                                        theme={theme => setTemaSeletor(theme)} />
                                                </FormGroup>
                                            </Col>
                                        }

                                        {this.controller.listaHoras.length > 0
                                            && <Col xs={12} md={4} lg={4} xl={3} className="pl-2" >
                                                <FormGroup className="footer-select">
                                                    <Label className="footer-select--label">Hora</Label>
                                                    <Select className="select" placeholder={""}
                                                        noOptionsMessage={() => { "Sem opções" }}
                                                        isClearable={true}
                                                        isSearchable={this.controller.listaHoras.length > 5}
                                                        defaultValue={this.controller.listaHoras.filter(option => option.value === _.get(this.controller.dadosAgendamento, "Agend.HoraAgend"))}
                                                        onChange={(event) => this.controller.setHoraAgend(event)}
                                                        menuPlacement="auto"
                                                        options={this.controller.listaHoras}
                                                        theme={theme => setTemaSeletor(theme)} />
                                                </FormGroup>
                                            </Col>
                                        }

                                        <Col xs={"auto"} xl={2} className="ml-auto ml-2">
                                            {!this.controller.salvar
                                                ? <div><Button className="btn-primary" onClick={this.handleFinalizar}>FINALIZAR AGENDAMENTO</Button></div>
                                                : <IconeCarregar tamanho="2x" />
                                            }
                                        </Col>
                                    </Row>
                                    : <IconeCarregar tamanho="2x" />
                                }

                            </Footer>
                        </Container>
                    </div>
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/telas/AgendamentoCadastrar.js